import React from "react";

const PageNotFound = () => {
  return (
    <div className="blog flex min-h-screen justify-center items-center">
      Page Doesn't Exist
    </div>
  );
};

export default PageNotFound;
